import Storage from '@storage';
import Plan from '../../classes/plan';
import User, { UserOperator } from '../../classes/user';
import { IUserState } from '../../types/interfaces/states';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IUserState = {
  ...(Storage.get('userToken')
    ? User.default().getData()
    : User.anonymous().getData()),
  initialized: false,
  userId: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    addExtraPlan: (state, action: PayloadAction<Plan | undefined>) => {
      if (state.isAnonymous || !action.payload) return;
      if (state.extraPlans?.length) {
        (state.extraPlans as Plan[]).push(action.payload);
      } else {
        state.extraPlans = [action.payload];
      }
    },
    disableParental: (state) => {
      state.parental = { ...state.parental, enabled: false };
    },
    enableParental: (state) => {
      state.parental = { ...state.parental, enabled: true };
    },
    removeInitialized: (state) => {
      state.initialized = false;
    },
    setInitialized: (state) => {
      state.initialized = true;
    },
    setCarrier: (state, action: PayloadAction<string | null>) => {
      if (action.payload) {
        state.carrierId = action.payload;
      }
    },
    setOperator: (state, action: PayloadAction<UserOperator>) => {
      state.operator = { ...state.operator, ...action.payload };
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setUser: (state, action: PayloadAction<User>) => {
      const {
        amazonAccount,
        carrierId,
        channelsOrder,
        email,
        extraPlans,
        freemiumFilter,
        isAnonymous,
        mobile,
        name,
        parental,
        planId,
        postalCode,
        token,
        username,
        userId,
        isTest,
      } = action.payload.data || {};
      state.amazonAccount = amazonAccount;
      state.carrierId = carrierId;
      state.channelsOrder = channelsOrder;
      state.email = email;
      state.extraPlans = extraPlans;
      state.freemiumFilter = freemiumFilter;
      state.isAnonymous = isAnonymous;
      state.mobile = mobile;
      state.name = name;
      state.parental = parental;
      state.planId = planId;
      state.postalCode = postalCode;
      state.token = token;
      state.username = username;
      state.userId = userId;
      state.metadata = action.payload.metadata;
      state.operator = { ...state.operator, ...action.payload.operator };
      state.isTest = isTest;
    },
  },
});

const { actions, reducer: userReducer } = userSlice;
export const {
  addExtraPlan,
  disableParental,
  enableParental,
  removeInitialized,
  setInitialized,
  setOperator,
  setToken,
  setCarrier,
  setUser,
  setUserId,
} = actions;
export const userSelector = (state: RootState) => state.user;
export default userReducer;
